import { priceSimulationActionTypes as actionTypes } from '../ActionTypes/priceSimulationActionTypes';
import { apiThunk } from '../Utils/apiThunk';
import type { components } from '../Types/api';
import type { PackageProposalPayload } from '../Components/PriceSimulation/proposalPayloadExtractor';
import type { AppDispatch } from '../Store/types';

type Schemas = components['schemas'];
type PackageListItemDto = Schemas['Cockpit.Models.PriceSimulation.PackageListItemDto'];
type ReviewerDto = Schemas['Cockpit.Models.PriceSimulation.ReviewerDto'];
type PriceSimulationPackageContextsRequest = Schemas['Cockpit.Models.PriceSimulation.PriceSimulationPackageContextsRequest'];
type PriceSimulationPackageContextsResponse = Schemas['Cockpit.Models.PriceSimulation.PriceSimulationPackageContextsResponse'];

interface SubmitForApprovalPayload {
    packages: PackageProposalPayload[];
    reviewerIds: number[];
    publishDate: string | null;
    notes: string | null;
}

const priceSimulationActions = {
    getPackages: () => {
        return (dispatch: AppDispatch) =>
            dispatch(apiThunk<PackageListItemDto[]>('/api/price-simulations/packages/', { loadingKey: 'packages' })).then((data) => {
                if (data) dispatch({ type: actionTypes.STORE_PRICE_SIMULATION_PACKAGES, data });
            });
    },

    fetchPriceSimulationPackageContexts: (packageIds: string[]) => {
        const body: PriceSimulationPackageContextsRequest = { packageIds };
        return (dispatch: AppDispatch): Promise<string[]> =>
            dispatch(
                apiThunk<PriceSimulationPackageContextsResponse>('/api/price-simulations/packages/contexts', {
                    loadingKey: 'packageContexts',
                    init: { method: 'POST', body: JSON.stringify(body) },
                })
            ).then((json) => {
                if (!json) return packageIds;
                dispatch({ type: actionTypes.STORE_PRICE_SIMULATION_PACKAGE_CONTEXTS, contexts: json.contexts ?? [] });
                return json.failedPackageIds ?? [];
            });
    },

    fetchReviewers: () => {
        return (dispatch: AppDispatch) =>
            dispatch(apiThunk<ReviewerDto[]>('/api/price-simulations/reviewers', { loadingKey: 'reviewers' })).then((data) => {
                if (data) dispatch({ type: actionTypes.STORE_REVIEWERS, data });
            });
    },

    submitForApproval: (payload: SubmitForApprovalPayload) => {
        return (dispatch: AppDispatch) =>
            dispatch(
                apiThunk<unknown>('/api/price-simulations/proposals/submit-for-approval', {
                    loadingKey: 'submitApproval',
                    init: { method: 'POST', body: JSON.stringify(payload) },
                    rethrow: true,
                })
            ).then((json) => {
                dispatch({ type: actionTypes.SUBMIT_FOR_APPROVAL_SUCCESS });
                return json;
            });
    },

    saveDraftProposals: (packages: PackageProposalPayload[]) => {
        return (dispatch: AppDispatch) =>
            dispatch(
                apiThunk<unknown>('/api/price-simulations/proposals', {
                    loadingKey: 'saveDraft',
                    init: { method: 'PUT', body: JSON.stringify({ packages }) },
                    rethrow: true,
                })
            ).then((json) => {
                dispatch({ type: actionTypes.SAVE_DRAFT_PROPOSALS, packages });
                return json;
            });
    },
};

export default priceSimulationActions;
